// IE 2026 11 03 / ODOO-350449 (заказ Игоря: визуальный выбор размера в меню виджета; поправка по пробе p237): поиск форм-меню (MenuPanel) находит пункты и по горячей клавише —
// запрос вида «Alt 3», «alt+3», «Shift Alt F», «Ctrl-Shift-S» сравнивается с hotkey пункта (порядок модификаторов и регистр не важны), без нечёткого совпадения по тексту;
// прочие запросы — как раньше (лестница поиска по названиям). Выключатель — настройка базы / браузера fe.ux.menuSearchHotkeys (по умолчанию ВКЛ).
// Чистые функции без Vue и стора — tests/unit/menuSearchHotkey.test.mjs.

export const MENU_SEARCH_HOTKEYS_FLAG = 'fe.ux.menuSearchHotkeys'

export function menuSearchHotkeys_on(store) {
    try {
        if (!store || typeof store.setting !== 'function') return true
        return store.setting(MENU_SEARCH_HOTKEYS_FLAG, true) !== false
    } catch (e) { return true }
}

const MODS = { ctrl: 'ctrl', control: 'ctrl', ctl: 'ctrl', alt: 'alt', option: 'alt', opt: 'alt', shift: 'shift', cmd: 'meta', command: 'meta', meta: 'meta', win: 'meta' }
const MOD_ORDER = ['ctrl', 'alt', 'shift', 'meta']
const NAMED = { esc: 'escape', escape: 'escape', enter: 'enter', return: 'enter', tab: 'tab', space: 'space', del: 'delete', delete: 'delete', ins: 'insert', insert: 'insert',
    backspace: 'backspace', home: 'home', end: 'end', pageup: 'pageup', pagedown: 'pagedown', pgup: 'pageup', pgdn: 'pagedown',
    up: 'up', down: 'down', left: 'left', right: 'right', arrowup: 'up', arrowdown: 'down', arrowleft: 'left', arrowright: 'right' }

// сочетание клавиш → нормальная форма «ctrl+alt+shift+meta+<клавиша>» (модификаторы — в постоянном порядке, клавиша в нижнем регистре) либо null:
// нужен хотя бы один модификатор и ровно одна клавиша (один символ, F1–F24 или имя клавиши); разделители — пробел, «+», «-»
export function hotkey_norm(text) {
    const s = String(text ?? '').trim().toLowerCase()
    if (!s || s.length > 40) return null
    const toks = s.replace(/([a-z0-9])-(?=\S)/g, '$1 ').split(/[\s+]+/).filter(Boolean)
    const mods = new Set()
    let key = null
    for (const tk of toks) {
        if (MODS[tk]) { mods.add(MODS[tk]); continue }
        if (key !== null) return null
        if (tk.length === 1) key = tk
        else if (/^f([1-9]|1\d|2[0-4])$/.test(tk)) key = tk
        else if (NAMED[tk]) key = NAMED[tk]
        else return null
    }
    if (!mods.size || key === null) return null
    return [...MOD_ORDER.filter(m => mods.has(m)), key].join('+')
}

// запрос поиска — сочетание клавиш (нормальная форма) либо null (обычный текстовый запрос)
export function hotkeyQuery_parse(q) { return hotkey_norm(q) }

// у пункта эта горячая клавиша: hotkey пункта в нормальной форме совпадает с запросом
export function hotkey_matches(itemHotkey, norm) {
    if (!norm || !itemHotkey) return false
    return hotkey_norm(itemHotkey) === norm
}

// матчер запроса-сочетания для лестницы поиска MenuPanel: та же форма, что у searchLadder (found, query, test / testRow), но текст не проверяет —
// совпадение решает hotkey пункта (MenuPanel._shownFilter, поле hotkey матчера)
export function hotkeyMatcher(q, norm, hotkeys) {
    const found = Array.isArray(hotkeys) ? hotkeys.some(h => hotkey_matches(h, norm)) : false
    return { query: q, hotkey: norm, found, tier: 0, conv: '', lang: '', extra: false, test: () => null, testRow: () => null }
}
